"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["White"] = "ty-bg-white";
    BackgroundColor["Black"] = "ty-bg-black";
    BackgroundColor["Orange"] = "ty-bg-orange";
    BackgroundColor["Red"] = "ty-bg-red";
    BackgroundColor["Green"] = "ty-bg-green";
    BackgroundColor["DarkGray"] = "ty-bg-dark-gray";
    BackgroundColor["SoftGray"] = "ty-bg-soft-gray";
    BackgroundColor["BorderGray"] = "ty-bg-border-gray";
    BackgroundColor["Beige"] = "ty-bg-beige";
    BackgroundColor["SoftRed"] = "ty-bg-soft-red";
    BackgroundColor["SoftOrange"] = "ty-bg-soft-orange";
})(BackgroundColor = exports.BackgroundColor || (exports.BackgroundColor = {}));
